import { useState } from 'react';

const heroImage = 'https://readdy.ai/api/search-image?query=Cinematic%20abstract%20digital%20entertainment%20composition%20with%20warm%20coral%20amber%20and%20golden%20gradients%20representing%20online%20video%20streaming%20platform%20modern%20aesthetic%20soft%20light%20elements%20flowing%20shapes%20play%20button%20icon%20shape%20integrated%20into%20artistic%20abstract%20geometric%20forms%20editorial%20digital%20art%20high%20quality%20luxurious%20atmosphere&width=960&height=680&seq=hero-main-2026&orientation=landscape';

export default function Hero() {
  const [imgError, setImgError] = useState(false);

  return (
    <section id="hero" className="relative w-full pt-16 md:pt-20">
      <div className="w-full px-4 md:px-6 lg:px-10 py-8 md:py-14 lg:py-18">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16">
          <div className="flex-1 w-full lg:max-w-[55%]">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium bg-accent-100 text-accent-900 rounded-full mb-5">
              <i className="ri-sparkling-line" />
              免费高清视频在线看 · 零成本畅享
            </span>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-foreground-950 leading-tight mb-4">
              91免费视频网站
              <span className="block text-2xl sm:text-3xl lg:text-4xl xl:text-5xl text-foreground-700 font-semibold mt-1">免费在线视频大全</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 mb-5 font-medium">
              汇聚91免费在线视频、91麻豆免费视频网站、91福利视频在线等海量资源
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-2xl">
              91免费视频网站致力于打造最全面的免费在线视频聚合平台，覆盖91免费在线视频、91麻豆免费视频网站、91福利视频在线等多元内容板块。每日稳定更新数百部高清资源，支持PC与移动端流畅播放，零成本享受沉浸式观影体验。无论您是寻找热门推荐、经典合集还是新锐原创，这里都能满足您的观看需求。
            </p>

            <div className="flex flex-wrap items-center gap-5 md:gap-6 mb-8">
              <div className="flex items-center gap-2.5">
                <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center">
                  <div className="w-5 h-5 flex items-center justify-center text-primary-600">
                    <i className="ri-upload-cloud-2-line" />
                  </div>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">每日上新500+</p>
                  <p className="text-xs text-foreground-500">稳定更新不断档</p>
                </div>
              </div>
              <div className="w-px h-10 bg-background-300/60 hidden sm:block" />
              <div className="flex items-center gap-2.5">
                <div className="w-10 h-10 rounded-xl bg-accent-100 flex items-center justify-center">
                  <div className="w-5 h-5 flex items-center justify-center text-accent-700">
                    <i className="ri-hd-line" />
                  </div>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">95%高清资源</p>
                  <p className="text-xs text-foreground-500">1080P超清观影</p>
                </div>
              </div>
              <div className="w-px h-10 bg-background-300/60 hidden sm:block" />
              <div className="flex items-center gap-2.5">
                <div className="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center">
                  <div className="w-5 h-5 flex items-center justify-center text-secondary-700">
                    <i className="ri-shield-check-line" />
                  </div>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-800">安全认证</p>
                  <p className="text-xs text-foreground-500">全站绿色浏览</p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }}
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap text-sm"
              >
                <i className="ri-play-circle-line text-base" />
                立即观看热门推荐
              </a>
              <a
                href="#features"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#features')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }}
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 border border-background-300/60 text-foreground-700 font-medium rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap text-sm"
              >
                了解平台特色
                <i className="ri-arrow-right-line" />
              </a>
            </div>
          </div>

          <div className="w-full lg:w-[45%] max-w-xl lg:max-w-none">
            {!imgError ? (
              <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-[4/3]">
                <img
                  src={heroImage}
                  alt="91免费视频网站 - 免费在线视频大全"
                  className="w-full h-full object-cover"
                  onError={() => setImgError(true)}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent" />
                <div className="absolute bottom-5 left-5 right-5 flex items-center gap-3">
                  <div className="flex-1 bg-background-50/95 backdrop-blur-sm rounded-xl px-4 py-3 border border-background-200/50">
                    <p className="text-xs text-foreground-500">当前热门</p>
                    <p className="text-sm font-semibold text-foreground-950">本周最热福利视频合集</p>
                  </div>
                  <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center shadow-sm">
                    <div className="w-5 h-5 flex items-center justify-center text-background-50">
                      <i className="ri-play-fill text-lg" />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="rounded-2xl bg-background-100 aspect-[4/3] flex items-center justify-center">
                <div className="text-center">
                  <div className="w-20 h-20 mx-auto rounded-full bg-primary-100 flex items-center justify-center mb-3">
                    <i className="ri-play-circle-line text-4xl text-primary-500" />
                  </div>
                  <p className="text-sm font-medium text-foreground-500">91免费视频网站</p>
                  <p className="text-xs text-foreground-400 mt-1">免费在线视频大全</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}